import { formatPublicCategoryLabel } from "@/features/public-site/public-site.utils";
import { Breadcrumb } from "@/features/layout/components/breadcrumb";
import type { ShopPageHeaderProps } from "@/features/shop/components/shop-page.types";
import { cn } from "@/lib/utils";

export function ShopPageHeader({
  selectedCategory,
  searchQuery,
  className,
}: ShopPageHeaderProps) {
  const categoryLabel = selectedCategory ? formatPublicCategoryLabel(selectedCategory) : null;
  const breadcrumbItems = [
    { label: "Home", url: "/" },
    { label: "Shop", url: "/shop" },
    ...(categoryLabel ? [{ label: categoryLabel, url: "/shop" }] : []),
  ];

  return (
    <section
      className={cn(
        "mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between",
        className,
      )}
    >
      <div className="space-y-3">
        <Breadcrumb items={breadcrumbItems} className="text-sm text-muted-foreground" />
        <div>
          <p className="text-sm text-muted-foreground md:text-base">
            {searchQuery
              ? `Showing results for "${searchQuery}".`
              : categoryLabel
                ? `Showing ${categoryLabel.toLowerCase()} products.`
                : "Full product catalog."}
          </p>
        </div>
      </div>
    </section>
  );
}
